import React, { useEffect } from 'react';

function MyComponent({url}) {

    useEffect(()=>{
        window.location.href=url;
    },[])
    

  return (
<></>
  );
}

export default MyComponent;
